export const FACEBOOK_OAUTH_SCOPES =
  "public_profile,pages_show_list,pages_manage_metadata,pages_read_engagement,pages_messaging,business_management";

export const INSTAGRAM_OAUTH_SCOPES =
  "public_profile,instagram_basic,instagram_manage_messages,pages_show_list,pages_manage_metadata,pages_read_engagement,pages_messaging,business_management";

export const logFacebookOAuthInit = (channel, requestedScopes) => {
  console.group(`[Facebook OAuth][${channel}] iniciando login`);
  console.log("requestedScopes (prop scope → FB.login):", requestedScopes);
  console.log("REACT_APP_FACEBOOK_APP_ID:", process.env.REACT_APP_FACEBOOK_APP_ID);
  console.groupEnd();
};

export const logFacebookOAuthDebug = (response, { channel = "facebook", requestedScopes } = {}) => {
  const prefix = `[Facebook OAuth][${channel}]`;

  console.group(`${prefix} respuesta runtime`);
  console.log("requestedScopes:", requestedScopes);
  console.log("appId:", process.env.REACT_APP_FACEBOOK_APP_ID);
  console.log("callback response completo:", response);
  console.log("authResponse.grantedScopes:", response.grantedScopes ?? "(ausente — verificar returnScopes={true})");

  if (response.grantedScopes && requestedScopes) {
    const granted = response.grantedScopes.split(",").map((s) => s.trim()).filter(Boolean);
    const requested = requestedScopes.split(",").map((s) => s.trim()).filter(Boolean);
    const notGranted = requested.filter((scope) => !granted.includes(scope));
    if (notGranted.length) {
      console.warn("scopes solicitados pero NO en grantedScopes:", notGranted);
    }
  }

  const accessToken = response.accessToken;
  if (!accessToken || typeof window === "undefined" || !window.FB) {
    console.warn("Sin accessToken o FB SDK — omitiendo /me/permissions y /me/accounts");
    console.groupEnd();
    return;
  }

  window.FB.api("/me/permissions", (permRes) => {
    console.log(`${prefix} GET /me/permissions:`, permRes);
    const permissions = permRes?.data || [];
    const declined = permissions.filter((p) => p.status === "declined");
    const granted = permissions.filter((p) => p.status === "granted");
    if (declined.length) {
      console.warn(`${prefix} declinedPermissions:`, declined.map((p) => p.permission));
    } else {
      console.log(`${prefix} declinedPermissions: (ninguno)`);
    }
    console.log(`${prefix} grantedPermissions:`, granted.map((p) => p.permission));
  });

  window.FB.api("/me/accounts?fields=name,id", (accRes) => {
    console.log(`${prefix} GET /me/accounts:`, accRes);
    console.log(`${prefix} /me/accounts count:`, accRes?.data?.length ?? 0);
  });

  console.groupEnd();
};
